import { ImageProps } from '../../interfaces';
import { Image } from '../image/Image';
import css from './thumbnail.module.scss';

interface ThumbnailProps extends React.HTMLAttributes<HTMLDivElement> {
  image: ImageProps;
  icon: React.ComponentType<React.SVGProps<SVGSVGElement>> | null;
  progress?: number;
  interactions?: {
    backdrop?: 'hover' | 'always' | 'never';
    icon?: 'hover' | 'always' | 'never';
  };
  iconText?: string;
}

const defaultInteractions = {
  backdrop: 'hover',
  icon: 'hover',
} as const;

export function Thumbnail({
  icon: Icon,
  image,
  progress,
  interactions = defaultInteractions,
  iconText,
  ...rest
}: ThumbnailProps) {
  return (
    <div
      className={css.thumbnail}
      data-interaction-backdrop={interactions.backdrop}
      data-interaction-icon={interactions.icon}
      {...rest}
    >
      {Icon && (
        <div className={css.iconContainer}>
          <Icon className={css.icon} width={32} height={32} />
          {iconText && <p className={css.iconText}> {iconText} </p>}
        </div>
      )}

      <Image className={css.image} src={image.src} alt={image.alt} loading="lazy" />
      {progress !== undefined && <progress className={css.progress} max={100} value={progress} />}
    </div>
  );
}
